const activities = [
  'Adventurous',
  'Romantic',
  'Religious',
  'Heritage',
  'Relaxing',
]

const terrains = ['Beach', 'Hills', 'Forest', 'Desert']
export { activities, terrains }
